import { Ref } from "react";
import customerService from "apis/customerService";
import { WebApiRequest, HTTP_POST, HTTP_GET, HTTP_PUT, HTTP_DELETE } from "../../tools/webservice";
import { 
  CustomerServiceIncidentAdd, 
  CustomerServiceIncidentAttachmentMetadata, 
  CustomerServiceIncidentUpdate,
  CustomerServiceIncidentAddFromCustomer,
  CustomerServiceIncidentDto,
} from "interfaces/Mueller.Business.Models";

export const addIncident = (payload: CustomerServiceIncidentAdd, successCallback: (incidentId: number) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST, 
  endpoint: customerService.addEditIncident(),
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});
export const updateIncident = (payload: CustomerServiceIncidentUpdate, successCallback: () => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: customerService.addEditIncident(),
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});
export const closeIncident = (incidentId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: customerService.closeIncident(incidentId),
  successCallback,
  mountedRef,
});
export const deleteIncident = (incidentId, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: customerService.deleteIncident(incidentId),
  successCallback,
  mountedRef,
});
export const getCustomerServiceAssignToUsers = () => WebApiRequest({
  method: HTTP_GET,
  endpoint: customerService.getCustomerServiceAssignToUsers(),
});
export const assignIncidents = (payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: customerService.assignIncidents(),
  payload,
  successCallback,
  errorCallback,
  mountedRef
});
export const addPendingIncidentAttachment = (fileName: string, arrayBuffer: ArrayBuffer, successCallback: (data: CustomerServiceIncidentAttachmentMetadata) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/customer-service/incident/attachments/${fileName}`,
  arrayBuffer,
  successCallback,
  errorCallback,
  mountedRef,
});
export const addIncidentAttachmentToExisting = (fileName: string, incidentId: number, arrayBuffer: ArrayBuffer, successCallback: (data: CustomerServiceIncidentAttachmentMetadata) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/customer-service/incident/attachments/${fileName}/${incidentId}`,
  arrayBuffer,
  successCallback,
  errorCallback,
  mountedRef,
});
export const deleteIncidentAttachment = (lookupKey: string, successCallback: () => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: `/customer-service/incident/attachments/${lookupKey}`,
  successCallback,
  errorCallback,
  mountedRef,
});
export const addIncidentNote = (incidentId, payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/customer-service/incident/${incidentId}/notes`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});
export const editIncidentNote = (incidentId, noteId, payload, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/customer-service/incident/${incidentId}/notes/${noteId}`,
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});
export const deleteIncidentNote = (incidentId, noteId, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: `/customer-service/incident/${incidentId}/notes/${noteId}`,
  successCallback,
  errorCallback,
  mountedRef,
});
export const addIncidentFromCustomer = (payload: CustomerServiceIncidentAddFromCustomer, successCallback: () => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_POST,
  endpoint: "/customer-service/customer-incident",
  payload,
  successCallback,
  errorCallback,
  mountedRef,
});
export const getAllIncidentsForCase = (controlNumber: number, successCallback: (incidents: CustomerServiceIncidentDto[]) => void, errorCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/customer-service/incidents/${controlNumber}`,
  successCallback,
  errorCallback,
  mountedRef,
});